import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule,ActivatedRoute}  from '@angular/router';
import { AppComponent } from '../../app.component';

import { TopnavComponent } from '../../topnav/topnav.component';
import { SidemenuComponent } from '../../sidemenu/sidemenu.component';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';
declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mesettings',
  templateUrl: './mesettings.component.html',
  styleUrls: ['./mesettings.component.css']
})
export class MesettingsComponent implements OnInit {
  FetchuserRestApiUrl: string = AppSettings.Edituser; 
  FetchMeSettingApiUrl: string = AppSettings.getmesettings;
  updateMeSettingAPI: string = AppSettings.updatemeSettings; 
  model: any = {
    ai_dollar: 0,
    me_ai: 0,
    me_main: 0,
    me_life: 0,
    physicaloffice_ww: 0,
    lawyer_ww: 0,
    advisor_ww: 0,
    areacenter_ww: 0,
    citycenter_ww: 0,
    statecenter_ww: 0,
    countrycenter_ww: 0,
    internationalcenter_ww: 0,
    worldwidecenter_ww: 0,
    channel_reg_cost: 0,
    group_reg_cost: 0
  };
  constructor(private CommonService: CommonService,private loginService: LoginService,private router: Router) { }

  ngOnInit() {
    this.model.id = localStorage.getItem('currentUserID');
    this.model.usergroup=localStorage.getItem('currentUsergroup');
    if(this.model.usergroup==2)
    {
      this.loginService.logout();
    }
    this.editmesetting(this.model.id);
  }
  editmesetting(id:any)
  {
    // call FetchMeSettingApiUrl and set  ai_dollar: 0,me_ai: 0, me_main: 0,me_life: 0
    this.CommonService.editdata(this.FetchuserRestApiUrl,id)
        .subscribe(resultdata =>{  
          console.log("userdata",resultdata); 
          this.model.user_data = resultdata.result; 
          this.model.user_type = resultdata.result.user_type; 
          if(resultdata.result.user_type == 2){
                      
            Swal.fire('Oops...', 'You are not authorized to access this page', 'error').then((result) => {
              this.router.navigate(['./dashboard']);
            });

          }      
    });
    this.CommonService.getdata(this.FetchMeSettingApiUrl)
        .subscribe(meresultdata =>{
          console.log("editmesetting",meresultdata.data[0]); 
          this.model.ai_dollar = meresultdata.data[0].ai_dollar;
          this.model.me_ai = meresultdata.data[0].me_ai;
          this.model.me_main = meresultdata.data[0].me_main;
          this.model.me_life = meresultdata.data[0].me_life; 
          this.model.id = meresultdata.data[0].id; 
          this.model.physicaloffice_ww = meresultdata.data[0].physicaloffice_ww;
          this.model.lawyer_ww = meresultdata.data[0].lawyer_ww;
          this.model.advisor_ww = meresultdata.data[0].advisor_ww;
          this.model.areacenter_ww = meresultdata.data[0].areacenter_ww;
          this.model.citycenter_ww = meresultdata.data[0].citycenter_ww;
          this.model.statecenter_ww = meresultdata.data[0].statecenter_ww;
          this.model.countrycenter_ww = meresultdata.data[0].countrycenter_ww;
          this.model.internationalcenter_ww = meresultdata.data[0].internationalcenter_ww;
          this.model.worldwidecenter_ww = meresultdata.data[0].worldwidecenter_ww;
          this.model.channel_reg_cost = meresultdata.data[0].channel_reg_cost;
          this.model.group_reg_cost = meresultdata.data[0].group_reg_cost;
    });
  }
 

  updateMesetting() {
 
  const postData = {
    id: this.model.id,
    user_id: this.model.id,
    ai_dollar: this.model.ai_dollar,
    me_ai: this.model.me_ai,
    me_main: this.model.me_main,
    me_life: this.model.me_life,
    physicaloffice_ww: this.model.physicaloffice_ww,
    lawyer_ww: this.model.lawyer_ww,
    advisor_ww: this.model.advisor_ww,
    areacenter_ww: this.model.areacenter_ww,
    citycenter_ww: this.model.citycenter_ww,
    statecenter_ww: this.model.statecenter_ww,
    countrycenter_ww: this.model.countrycenter_ww,
    internationalcenter_ww: this.model.internationalcenter_ww,
    worldwidecenter_ww: this.model.worldwidecenter_ww,
    channel_reg_cost: this.model.channel_reg_cost,
    group_reg_cost: this.model.group_reg_cost
  };

  this.CommonService.updatedata(this.updateMeSettingAPI, postData)
    .subscribe(res => {
      swal(
          res.status,
          res.message,
        )
        this.ngOnInit();
    });
  }

  
}
